export function generatePassword(): string {
  let password = '';
  let charsString = 'qwertyuiopasdfghjklzxcvbnmQWERTYUIOPASDFGHJKLZXCVBNM1234567890';
  for (let i = 0; i < 8; i++) {
    password += charsString.charAt(Math.round(Math.random() * charsString.length));
  }
  return password;
}



// WEBPACK FOOTER //
// ./src/modules/admin/utils/passwordGenerator.ts